import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Footer } from './Footer';

const UnsubscribePage = () => {
  const { token } = useParams();
  const [selected, setSelected] = useState('all_emails');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitStatus, setSubmitStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    setSubmitStatus('');

    try {
      const response = await fetch(`/api/unsubscribe/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: selected }),
      });

      const data = await response.json();

      if (data.success) {
        setSubmitStatus('success');
        setSubmitMessage('You have been successfully unsubscribed from our email communications.');
      } else {
        throw new Error(data.message || 'Unsubscribe failed');
      }
    } catch (error) {
      setSubmitStatus('error');
      setSubmitMessage('Sorry, there was an error processing your request. Please try again or contact us at info@yuccan.tech.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
    <div className="telematics-page">
      {/* Logo Header */}
      <div className="telematics-header">
        <div className="container">
          <div className="header-content">
            <div className="logo-container">
              <a href="/">
                <img
                  src="/img/Banner_16x_TR_Trim&ColorEdit.png"
                  alt="Yuccan Technologies Logo"
                  className="telematics-logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Unsubscribe Section */}
      <section id="contact" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Manage Your Email Preferences</h2>
          </div>
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <p style={{fontSize: '16px', color: '#fff', marginBottom: '25px', textAlign: 'center'}}>
                Select which emails you would like to unsubscribe from:
              </p>

              <form onSubmit={handleSubmit} className="telematics-contact-form">
                {/* All Emails Option */}
                <div style={{clear: 'both', overflow: 'hidden', marginBottom: '15px'}}>
                  <label style={{display: 'flex', alignItems: 'flex-start', cursor: 'pointer', fontSize: '14px', color: '#fff', fontWeight: 'normal', float: 'none', width: '100%'}}>
                    <input
                      type="radio"
                      name="unsubscribe_type"
                      value="all_emails"
                      checked={selected === 'all_emails'}
                      onChange={(e) => setSelected(e.target.value)}
                      disabled={isSubmitting}
                      style={{marginRight: '10px', marginTop: '3px', flexShrink: 0}}
                    />
                    <span style={{textAlign: 'justify'}}>
                      <strong>All emails</strong> — Unsubscribe from all email communications from Yuccan Technologies.
                    </span>
                  </label>
                </div>

                {submitMessage && (
                  <div className={`alert ${submitStatus === 'success' ? 'alert-success' : 'alert-danger'}`}>
                    {submitMessage}
                  </div>
                )}

                {submitStatus !== 'success' && (
                  <div className="text-center" style={{marginTop: '20px'}}>
                    <button
                      type="submit"
                      className="btn btn-custom btn-lg"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Processing...' : 'Unsubscribe'}
                    </button>
                  </div>
                )}

                {submitStatus === 'success' && (
                  <p style={{fontSize: '14px', color: '#ccc', marginTop: '15px', textAlign: 'center'}}>
                    If this was a mistake, please contact us at{' '}
                    <a href="mailto:info@yuccan.tech" style={{color: '#2B4B8C'}}>info@yuccan.tech</a>
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
    </div>
  );
};

export default UnsubscribePage;
